
<template>
    
        <mars-view :style="{
        visibility,
        zIndex
    }" class="dialog"><mars-view class="dialog-inner"><mars-view :style="{
                opacity
            }" class="mask" @click.native="handleMaskTap" @touchmove.native.prevent></mars-view><mars-view :style="{
                width: mWidth + 'px',
                maxHeight: mMaxHeight + 'px',
                opacity,
                transform: 'scale(' + scale + ')',
                borderRadius: borderRadius ? borderRadius : {}
            }" class="layer"><mars-view class="top"><mars-view v-if="gapTop" :style="{
                        paddingTop: gapTop + 'px'
                    }" class="gap-top"></mars-view><mars-view v-if="title" class="title" @touchmove.native.prevent>
                    {{ title }}
                </mars-view><slot name="title"></slot><mars-view><mars-view v-if="content" ref="content" :style="{
                            maxHeight: contentMaxHeight + 'px',
                            textAlign: contentTextAlign,
                            color: contentColor ? contentColor : {}
                        }" class="content c-font-15 c-color-gray" @touchstart.native="handleContentTouchStart" @touchmove.native="handleContentTouchMove">
                        {{ content }}
                    </mars-view><mars-view v-else ref="contentSlot" :style="{
                            maxHeight: contentMaxHeight + 'px',
                            textAlign: contentTextAlign
                        }" class="slot" @touchstart.native="handleContentSlotTouchStart" @touchmove.native="handleContentSlotTouchMove"><slot></slot></mars-view></mars-view></mars-view><div v-if="gapBottom" :style="{
                    paddingBottom: gapBottom + 'px'
                }"></div><mars-view v-if="btnOpts && btnOpts.length > 0" class="bottom c-line-top" @touchmove.native.prevent><mars-view v-for="(btn, btnIndex) in btnOpts" :key="btnIndex" :style="{
                        color: btn.color,
                        fontSize: btn.fontSize,
                        borderLeft: btnIndex !== 0 ? '1px solid #eee' : ''
                    }" class="btn c-font-big c-color-link" @click.native="handleBtnTap($event, {
                        btn,
                        btnIndex
                    })">
                    {{ btn.text }}
                </mars-view></mars-view><mars-view @touchmove.native.prevent><slot name="btn"></slot></mars-view></mars-view></mars-view></mars-view>
    
</template>

<script>
import stopScrollThroughMixin from '../../mixins/stopScrollThroughMixin';
export default {
  mixins: [stopScrollThroughMixin],
  props: {
    /**
     * 是否显示
     */
    show: {
      type: Boolean,
      default: false
    },

    /**
     * 距离顶部的距离，单位为 px；默认为 23px；
     */
    gapTop: {
      type: Number,
      default: 23
    },

    /**
     * 距离底部的距离，单位为 px；默认为 0px；一般用于不显示按钮栏的时候做一些间距处理
     */
    gapBottom: {
      type: Number,
      default: 0
    },

    /**
     * 最大高度；<= 1 认为是百分比，> 1 认为是 px
     */
    maxHeight: {
      type: Number,
      default: .55
    },

    /**
     * 宽度；<= 1 认为是百分比，> 1 认为是 px
     */
    width: {
      type: Number,
      default: .8
    },

    /**
     * css z-index；默认为 921
     */
    zIndex: {
      type: String,
      default: '921'
    },

    /**
     * css border radius；默认为 '13px'
     */
    borderRadius: {
      type: String
    },

    /**
     * 标题
     */
    title: {
      type: String,
      default: ''
    },

    /**
     * 标题高度，单位为 px；默认高度为 48px，其中34px 是标题的高度；14px 是标题距离顶部的距离；注：当使用自定义 title slot 的时候，需要传入 title slot 的高度
     */
    titleHeight: {
      type: Number,
      default: 48
    },

    /**
     * 内容
     */
    content: {
      type: String,
      default: ''
    },

    /**
     * 内容文字颜色；默认为 '#999'
     */
    contentColor: {
      type: String
    },

    /**
     * 内容居中方式
     */
    contentTextAlign: {
      type: String,
      default: 'left'
    },

    /**
     * 按钮配置
     *
     * @property {string} event 该按钮绑定的事件名，点击该按钮时触发
     * @property {string} text 文案
     * @property {string} color 按钮文字颜色
     */
    btnOpts: {
      type: Array,
      default: function () {
        return [{
          event: 'cancel',
          text: '取消'
        }, {
          event: 'confirm',
          text: '确定'
        }];
      }
    },

    /**
     * 按钮 slot 的高度
     */
    btnSlotHeight: {
      type: Number
    }
  },

  data() {
    return {
      // 浮层的宽度
      mWidth: 0,
      // 最大高度
      mMaxHeight: 'auto',
      // 内容最大高度
      contentMaxHeight: 'auto',
      // 底部高度
      bottomHeight: 48,
      // 透明度
      opacity: 0,
      // 最外层隐藏或显示
      visibility: 'hidden',
      // 浮层的缩放
      scale: 1.17 // 是否有默认 slot
      // isDefaultSlot: false

    };
  },

  created() {
    // if (this.$slots.default && this.$slots.default.length) {
    // this.isDefaultSlot = true;
    // }
    this.calculateWidthHeight();
  },

  methods: {
    /**
     * 计算宽高
     */
    calculateWidthHeight() {
      let systemInfo = this.$api.getSystemInfoSync();
      this.screenWidth = systemInfo.screenWidth;
      this.screenHeight = systemInfo.screenHeight; // px

      if (this.width > 1) {
        this.mWidth = this.width;
      } // 百分比
      else {
          this.mWidth = parseInt(this.screenWidth * this.width, 10);
        } // 计算底部高度
      // 48 px 是底部按钮栏的高度


      if (this.btnOpts && this.btnOpts.length > 0) {
        this.bottomHeight = 48;
      } else if (this.gapBottom || this.btnSlotHeight) {
        this.bottomHeight = this.gapBottom ? this.gapBottom : 0 + this.btnSlotHeight ? this.btnSlotHeight : 0;
      } else {
        this.bottomHeight = 0;
      } // 得到最大高度


      if (this.maxHeight <= 1) {
        // 百分比
        this.mMaxHeight = parseInt(this.screenHeight * this.maxHeight, 10);
      } else {
        // 具体像素
        this.mMaxHeight = this.maxHeight;
      } // 得到内容区最大高度


      this.contentMaxHeight = this.mMaxHeight - this.gapTop - this.titleHeight - this.bottomHeight;
    },

    handleMaskTap() {
      /**
       * 蒙层点击
       *
       * @event masktap
       */
      this.$emit('masktap');
      /**
       * 关闭事件
       *
       * @event close
       */

      this.$emit('close');
    },

    handleBtnTap(e, obj) {
      // 0.3.x 版本中绑定函数参数时 $event 只能作为一个单独的参数
      // 不支持放到对象里 这里做兼容处理
      obj.e = e;
      /**
       * 按钮点击事件
       *
       * @event btnclick
       * @property {Event} param1.e 透传的事件对象
       * @property {number} param1.btnIndex 点击按钮的索引
       * @property {object} param1.btn 点击的按钮配置
       * @property {string} param1.btn.event 该按钮绑定的事件名
       * @property {string} param1.btn.text 该按钮的文案
       */

      this.$emit('btntap', obj); // 如果 .event 存在

      if (obj.btn.event) {
        /**
         * 确认事件
         *
         * @event confirm
         * @property {Event} param1.e 透传的事件对象
         * @property {number} param1.btnIndex 点击按钮的索引
         * @property {object} param1.btn 点击的按钮配置
         * @property {string} param1.btn.event 该按钮绑定的事件名
         * @property {string} param1.btn.text 该按钮的文案
         */

        /**
         * 取消事件
         *
         * @event cancel
         * @property {Event} param1.e 透传的事件对象
         * @property {number} param1.btnIndex 点击按钮的索引
         * @property {object} param1.btn 点击的按钮配置
         * @property {string} param1.btn.event 该按钮绑定的事件名
         * @property {string} param1.btn.text 该按钮的文案
         */
        this.$emit(obj.btn.event, obj);
      } // 如果事件名不是 close，触发 close


      if (obj.btn.event !== 'close') {
        /**
         * 关闭事件
         *
         * @event close
         */
        this.$emit('close');
      }
    },

    handleContentTouchStart(e) {
      this.handleTouchStartStopScrollThroughMixin(e);
    },

    handleContentTouchMove(e) {
      // 此代码块里的内容只渲染到h5端
      this.handleTouchMoveStopScrollThroughMixin(e, this.$refs.content.$el);
    },

    handleContentSlotTouchStart(e) {
      this.handleTouchStartStopScrollThroughMixin(e);
    },

    handleContentSlotTouchMove(e) {
      // 此代码块里的内容只渲染到h5端
      this.handleTouchMoveStopScrollThroughMixin(e, this.$refs.contentSlot.$el);
    }

  },
  watch: {
    show(newVal, oldVal) {
      if (newVal) {
        this.visibility = 'visible';
        this.opacity = 1;
        this.scale = 1;
      } else {
        this.opacity = 0;
        setTimeout(() => {
          this.visibility = 'hidden';
          this.scale = 1.17;
        }, 300);
      }
    }

  }
};
</script>

<style scoped>
.dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.dialog-inner {
  position: relative;
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.mask {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.65);
  -webkit-transition: opacity 0.16s cubic-bezier(0, 0, 0.3, 1);
  transition: opacity 0.16s cubic-bezier(0, 0, 0.3, 1);
}
.layer {
  z-index: 1;
  border-radius: 13px;
  background-color: #fff;
  -webkit-transition: opacity 0.3s cubic-bezier(0.14, 0.1, 0.12, 1);
  transition: opacity 0.3s cubic-bezier(0.14, 0.1, 0.12, 1);
}
.layer .top {
  padding-left: 24px;
  padding-right: 24px;
}
.layer .top .title {
  padding-bottom: 14px;
  text-align: center;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  color: #333;
  font: 24px/34px Arial, Helvetica, sans-serif;
}
.layer .top .content,
.layer .top .slot {
  padding-bottom: 25px;
  overflow: auto;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}
.layer .bottom {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 48px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
.layer .bottom .btn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
}

</style>
